import { useParams } from "react-router-dom";
import { useUpdateTTProtectionWithoutVersion } from "../Hooks/useUpdateTTProtectionWithoutVersion";
import { TTProtection } from "../TTProtection";
import { TTProtectionFormTabs } from "./TTProtectionFormTabs";
import { useFetchTTProtection } from "../Hooks/useFetchTTProtection";
import { useUpdateTTProtectionAsNewVersion } from "../Hooks/useUpdateTTProtectionAsNewVersion";

export default function EditTTProtection() {
  const { ttProtectionId } = useParams();
  const { data: ttProtection } = useFetchTTProtection(ttProtectionId);
  const { mutate: updateTTProtectionWithoutVersion } =
    useUpdateTTProtectionWithoutVersion(ttProtectionId);
  const { mutate: updateTTProtectionAsNewVersion } =
    useUpdateTTProtectionAsNewVersion(ttProtectionId);

  return (
    <TTProtectionFormTabs
      ttProtectionId={ttProtectionId ? parseInt(ttProtectionId, 10) : null}
      title="Edit TT Protection"
      ttProtection={ttProtection}
      onSaveWithoutVersion={(it: TTProtection) => updateTTProtectionWithoutVersion(it)}
      onSaveAsNewVersion={(it: TTProtection) => updateTTProtectionAsNewVersion(it)}
    />
  );
}
